<section pfSection pfTitle="Packing">
    <div class="packages">
        @for (vm of packageViewModels(); track vm.pkg.packingListNumber) {
            <article
                pfArticle
                [pfTitle]="'Package ' + vm.pkg.packingListNumber">
                <button
                    type="button"
                    class="package-remove-btn"
                    [disabled]="disabled() || totalPackages() <= 1"
                    [attr.aria-label]="
                        'Remove package ' + vm.pkg.packingListNumber
                    "
                    (click)="removePackage(vm.pkg.packingListNumber)">
                    <pf-icon iconType="close"></pf-icon>
                </button>
                <nz-radio-group
                    class="package-type-toggle"
                    [ngModel]="vm.packageType"
                    [nzDisabled]="disabled()"
                    nzButtonStyle="solid"
                    nzSize="large"
                    (ngModelChange)="
                        setPackageType(vm.pkg.packingListNumber, $event)
                    ">
                    <label nz-radio-button nzValue="box">Box</label>
                    <label nz-radio-button nzValue="pallet">Pallet</label>
                </nz-radio-group>
                <cpw-packing-form
                    [package]="vm.pkg"
                    [disabled]="disabled()"
                    [availableItems]="vm.availableItems"
                    [boxTypes]="boxTypes()"
                    [style]="style()"
                    [packageType]="vm.packageType"
                    (validChange)="
                        onPackageValidChange(vm.pkg.packingListNumber, $event)
                    "
                    (valueChange)="
                        onPackageValueChange(vm.pkg.packingListNumber, $event)
                    "></cpw-packing-form>
            </article>
        }
    </div>

    <div class="actions">
        <pf-button
            buttonType="add-item"
            [disabled]="!canAddPackage()"
            (click)="addPackage()">
            Add package for remaining items
        </pf-button>

        @if (allItemsPacked()) {
            <pf-button
                buttonType="submit"
                block
                [disabled]="disabled()"
                [loading]="saving()"
                (click)="confirmPackages()">
                {{ saving() ? "Saving..." : "Confirm Packages" }}
            </pf-button>
        }
    </div>
</section>
